var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7929 7.29289C13.1834 6.90237 13.8166 6.90237 14.2071 7.29289C14.5976 7.68342 14.5976 8.31658 14.2071 8.70711L10.2071 12.7071C9.81658 13.0976 9.18342 13.0976 8.79289 12.7071L4.79289 8.70711C4.40237 8.31658 4.40237 7.68342 4.79289 7.29289C5.18342 6.90237 5.81658 6.90237 6.20711 7.29289L8.5 9.58579L8.5 1C8.5 0.447716 8.94772 -6.58593e-09 9.5 0C10.0523 6.58593e-09 10.5 0.447716 10.5 1L10.5 9.58579L12.7929 7.29289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792893 13.2929C1.18342 12.9024 1.81658 12.9024 2.20711 13.2929L4.91421 16H14.0858L16.7929 13.2929C17.1834 12.9024 17.8166 12.9024 18.2071 13.2929C18.5976 13.6834 18.5976 14.3166 18.2071 14.7071L15.2071 17.7071C15.0196 17.8946 14.7652 18 14.5 18H4.5C4.23478 18 3.98043 17.8946 3.79289 17.7071L0.792893 14.7071C0.402369 14.3166 0.402369 13.6834 0.792893 13.2929Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ddc1a7a43d5889a61098f80e995f71ae.svg";
export { ForwardRef as ReactComponent };